module.exports = __webpack_public_path__ + "static/img/bottomimg.231d1b6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/companyprofilepic/bottomimg.png
// module id = 7oA1
// module chunks = 52